module.exports = __webpack_public_path__ + "img/IMG_9934-43_P_L_Black.a7f799e5.jpg";